import { render, staticRenderFns } from "./UploadResume.vue?vue&type=template&id=dfc28d68"
import script from "./UploadResume.vue?vue&type=script&lang=js"
export * from "./UploadResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports